export default __webpack_public_path__ + "static/media/cross.deab6012.svg";